import { useMemo } from 'react';
import {BrokerNerdsBarkerCoreModelsAdministrativePrincipal, BrokerNerdsBarkerCoreModelsInventoryEvent} from "../../api";

/**
 * Hook to manage tenant-specific branding colors and class names.
 * Preserves literal hex strings for IDE color gutter previews.
 */
export const useTenantTheme = (selectedEvent?: BrokerNerdsBarkerCoreModelsInventoryEvent | null, isMultiTenant?: boolean, principal?: BrokerNerdsBarkerCoreModelsAdministrativePrincipal) => {
  const tenantColorName = useMemo(() => {
    if (!selectedEvent?.eventId || !isMultiTenant) return 'brandcolor';

    // List all possible tenant colors from previous options
    const tenantRed = ['#C92A2A', '#F03E3E', '#FF6B6B', '#FFA8A8', 'var(--colors-tenant-red-5)', 'red'];
    const tenantOrange = ['#D9480F', '#F76707', '#FF922B', '#FFC078', 'var(--colors-tenant-orange-5)', 'orange'];
    const tenantYellow = ['#E67700', '#F59F00', '#FCC419', '#FFE066', 'var(--colors-tenant-yellow-5)', 'yellow'];
    const tenantGreen = ['#2B8A3E', '#37B24D', '#51CF66', '#8CE99A', 'var(--colors-tenant-green-5)', 'green'];
    const tenantCyan = ['#0B7285', '#1098AD', '#22B8CF', '#66D9E8', 'var(--colors-tenant-cyan-5)', 'cyan'];
    const tenantBlue = ['#1864AB', '#1C7ED6', '#339AF0', '#74C0FC', 'var(--colors-tenant-blue-5)', 'blue'];
    const tenantGrape = ['#862E9C', '#AE3EC9', '#CC5DE8', '#E599F7', 'var(--colors-tenant-grape-5)', 'grape'];
    const tenantPink = ['#A61E4D', '#D6336C', '#F06595', '#FAA2C1', 'var(--colors-tenant-pink-5)', 'pink'];
    const tenantBrandColor = ['#3d8161', '#63b187', 'var(--colors-brandgreen-5)', 'brandgreen', 'var(--colors-brandcolor-5)', 'brandcolor'];
    const tenantBlack = ['#000000', 'black'];
    const tenantGray4 = ['#333333', 'gray4'];
    const tenantGray3 = ['#666666', 'gray3'];
    const tenantGray2 = ['#999999', 'gray2'];
    const tenantGray1 = ['#E0E0E0', 'gray1'];

    const tenantColor = principal?.settings?.tenantColors[selectedEvent?.tenantId];

    if (tenantColor) {
      if (tenantBrandColor.includes(tenantColor)) return 'brandcolor';
      if (tenantRed.includes(tenantColor)) return 'red';
      if (tenantOrange.includes(tenantColor)) return 'orange';
      if (tenantYellow.includes(tenantColor)) return 'yellow';
      if (tenantGreen.includes(tenantColor)) return 'green';
      if (tenantCyan.includes(tenantColor)) return 'cyan';
      if (tenantBlue.includes(tenantColor)) return 'blue';
      if (tenantGrape.includes(tenantColor)) return 'grape';
      if (tenantPink.includes(tenantColor)) return 'pink';
      if (tenantBlack.includes(tenantColor)) return 'black';
      if (tenantGray4.includes(tenantColor)) return 'gray4';
      if (tenantGray3.includes(tenantColor)) return 'gray3';
      if (tenantGray2.includes(tenantColor)) return 'gray2';
      if (tenantGray1.includes(tenantColor)) return 'gray1';
    }
    return 'brandcolor';
  }, [selectedEvent?.eventId, selectedEvent?.tenantId, isMultiTenant, principal?.settings?.tenantColors]);

  const tenantClassName = isMultiTenant ? `tenant-${tenantColorName}` : 'tenant-single';

  return {
    tenantColorName,
    tenantClassName,
  };
};